<template>
    <vBudgetSourceListComponent :postList="postList"></vBudgetSourceListComponent>
</template>
<script>
import vBudgetSourceListComponent from '../../listComponent/budget/budgetSource/budgetSourceListComponent.vue';
export default {
    name: 'budgetSourceList',
    components: {
        vBudgetSourceListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                direction: true,
                scope: true,
                is_default: true,
                effectiveness: true,
                time_value: true,
                addBtn: true,
                okBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                params: {
                    tab_type: 1
                }
            }
        };
    },
    mounted() {

    },
    methods: {
       
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>